export default __webpack_public_path__ + "static/media/addPhoto.ea2ae261.svg";